import { z } from 'zod';
/**
 * Login — "AnvarAliyev" shaklida.
 *
 * Faqat lotin harflari va raqam: login xodimning ismidan yasaladi va u
 * TERILADIGAN narsa. Tutuq belgisi ham, chiziqcha ham, kirill ham
 * kiritilmaydi — ekranda bir xil ko'rinadigan ikki xil belgi ikki xil hisob
 * degani bo'lardi (`identity/domain/username.ts` shu sababli tozalaydi).
 */
export const usernameSchema = z
    .string()
    .trim()
    .min(3, 'Login kamida 3 belgidan iborat bo\'lishi kerak')
    .max(60)
    .regex(/^[A-Za-z][A-Za-z0-9]*$/, 'Login harf bilan boshlanib, faqat lotin harfi va raqamdan iborat bo\'lishi kerak');
/**
 * CAPTCHA — IKKI bosqichli.
 *
 * Avval kod alohida tekshiriladi (`POST /auth/captcha/verify`) va uning
 * o'rniga qisqa muddatli CHIPTA beriladi; kirish so'rovi esa faqat shu
 * chiptani olib boradi.
 *
 * Nega bir so'rovga qo'shib yuborilmadi: kod to'g'ri terilganini odam
 * DARHOL bilishi kerak. Bitta so'rov bo'lganda "kod noto'g'ri" javobi
 * parol bilan birga qaytardi va odam qaysi biri xato ekanini bilmasdi —
 * ustiga har urinishda yangi rasm terishga majbur bo'lardi.
 *
 * Chipta BIR MARTALIK EMAS: u bir soat yashaydi va shu manzildan kelgan
 * kirish urinishlarida qayta ishlatiladi (`captcha.service.ts` dagi
 * `PASS_TTL_SECONDS`). Butun maqsad shu — parolini bir marta xato yozgan
 * odam ikkinchi urinishida yana topishmoq yechmasin.
 */
export const captchaVerifySchema = z.object({
    captchaId: z.string().min(10).max(64),
    captchaAnswer: z.string().trim().min(1).max(16),
});
export const captchaTicketSchema = z.object({
    captchaToken: z.string().min(10).max(64),
});
export const loginSchema = z
    .object({
    username: usernameSchema,
    password: z.string().min(1).max(200),
})
    .merge(captchaTicketSchema);
/**
 * TELEGRAM orqali kirish.
 *
 * Ikki bosqich: brauzer so'rov ochadi (`start`) va natijani so'rab turadi
 * (`status`). Ikkalasi orasida odam Telegramda tugma bosadi.
 *
 * `pollSecret` javobda BIR MARTA qaytadi va brauzerdan chiqmaydi: havoladagi
 * `nonce` Telegramga ochiq ketgani uchun, uni ko'rgan begona odam natijani
 * so'rab ola olmasligi kerak.
 *
 * Telegram yo'li CAPTCHA so'ramaydi va bu ataylab: u AYRIM yo'l.
 *
 * CAPTCHA parolni terib ko'rishni qimmatlashtirish uchun; Telegramda esa
 * teriladigan parol yo'q — odam o'z ilovasida tugma bosadi. Kod so'rash
 * faqat ikkita yo'lning ikkalasini ham bir-biriga bog'lab qo'yardi:
 * rasmni yechmaguncha Telegram tugmasi ham o'chiq turardi.
 *
 * So'rov ochilishini tezlik chegarasi (`AuthThrottle`) qo'riqlaydi.
 */
export const telegramLoginStartSchema = z.object({});
export const telegramLoginStatusSchema = z.object({
    nonce: z.string().min(10).max(64),
    pollSecret: z.string().min(10).max(64),
});
export const refreshSchema = z.object({
    refreshToken: z.string().min(20).max(300),
});
/**
 * Parolni ALMASHTIRISH — foydalanuvchining o'zi.
 *
 * Eski parol SO'RALADI, hattoki majburiy almashtirish holatida ham:
 * ochiq qolgan begona brauzer parolni jimgina o'zgartirib, hisobni
 * butunlay egallab olmasligi kerak.
 */
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: z.string().min(1).max(200),
});
//# sourceMappingURL=auth.js.map